import { render } from "./DetailLesson.vue?vue&type=template&id=19686999"
import script from "./DetailLesson.vue?vue&type=script&lang=js"
export * from "./DetailLesson.vue?vue&type=script&lang=js"

import "./DetailLesson.vue?vue&type=style&index=0&id=19686999&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__